import { render, staticRenderFns } from "./TeamAvatar.vue?vue&type=template&id=fbec67a8&scoped=true"
import script from "./TeamAvatar.vue?vue&type=script&lang=js"
export * from "./TeamAvatar.vue?vue&type=script&lang=js"
import style0 from "./TeamAvatar.vue?vue&type=style&index=0&id=fbec67a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbec67a8",
  null
  
)

export default component.exports